<template>
  <div>
    <SelectWorkShift v-model="form.workShiftId" :initial-datas="form.workShift ? [form.workShift] : null" :selectProps="{
      style: { width: '100%' },
      placeholder: 'Shift',
      value: form.workShiftId || undefined,
    }" :variables-query="{ isOvertime: false }" :isGetDataCreated="false" :set-value-results="(value) => {
          setFormItem('workShift', value || {});
          checkIsDifferentDurationShift();
          processChangeNewAnnualLeave();
        }
        " />
    <section v-if="form.workShiftId" class="highlight-wrapper">
      <!-- <div style="color: #777; font-size: 15px;">
        <p style="margin-top: 5px;">
          CURRENT MAIN SHIFT
        </p>
      </div> -->
      <div>
        <CompareWorkShift v-if="employee.workShift && form.workShift" :workShift="employee.workShift"
          :newWorkShift="form.workShift" />
        <InfoWorkShift v-else-if="!employee.workShift" :workShift="form.workShift" />
        <br />
        <div v-if="employee.annualLeaveDay">
          <a-checkbox v-if="isDiffShift" v-model="form.isUpdateAnnualLeave">
            Update annual leave day
            <small> (check if you want update annual leave ) </small>
          </a-checkbox>
          <a-descriptions v-if="form.isUpdateAnnualLeave" style="margin-top: 20px;" :column="1"
            title="Annual leave day / Nghỉ phép năm">
            <a-descriptions-item label="Original Day / Ngày nghỉ phép năm ban đầu">
              <span v-if="employee.annualLeaveDay">
                {{
                  (+employee.annualLeaveDay.original / +employeeShift.duration)
                  | numParseFloat(2)
                }}
              </span>
            </a-descriptions-item>
            <a-descriptions-item label="Total day annual leave/ Tổng số ngày nghỉ phép năm">
              <span v-if="employee.annualLeaveDay">
                {{ +employee.annualLeaveDay.default }}
              </span>
              ->
              <span class="new-shift" v-if="employee.annualLeaveDay">
                {{ annualLeaveDay.default | numParseFloat(2) }}
              </span>
            </a-descriptions-item>
            >
            <a-descriptions-item label="Total hour annual leave / Tổng số giờ nghỉ phép năm">
              <span v-if="employee.annualLeaveDay">
                {{
                  (+employee.annualLeaveDay.default / +employeeShift.duration)
                  | numParseFloat(2)
                }}
              </span>
            </a-descriptions-item>
            <a-descriptions-item label="Original Hour / Giờ nghỉ phép năm ban đầu">
              <span v-if="employee.annualLeaveDay">
                {{ +employee.annualLeaveDay.original }}
              </span>
              ->
              <span class="new-shift" v-if="employee.annualLeaveDay">
                {{ annualLeaveDay.original | numParseFloat(2) }}
              </span>
            </a-descriptions-item>

            <a-descriptions-item label="Total day annual leave remain / Số ngày nghỉ phép còn lại">
              <span v-if="employee.annualLeaveDay">
                {{
                  (+employee.annualLeaveDay.remain / +employeeShift.duration)
                  | numParseFloat(2)
                }}
              </span>
            </a-descriptions-item>
            <a-descriptions-item label="Total hour annual leave remain / Số giờ nghỉ phép còn lại">
              <span v-if="employee.annualLeaveDay">
                {{ +employee.annualLeaveDay.remain }}
              </span>
              ->
              <span class="new-shift" v-if="employee.annualLeaveDay">
                {{ annualLeaveDay.remain | numParseFloat(2) }}
              </span>
            </a-descriptions-item>
          </a-descriptions>
        </div>
      </div>
    </section>
    <div style="margin-top: 20px; text-align: right;">
      <a-button v-if="form.workShiftId" type="danger" style="float: left;" @click="onRemoveShift" icon="delete">
        Remove shift
      </a-button>
      <a-button style="margin-right: 5px;" @click="close"> Close </a-button>
      <a-button type="primary" icon="save" :loading="loadingBtn" @click="onSubmit">
        Save
      </a-button>
    </div>
  </div>
</template>

<script>
import queryAnnualLeaveDay from "../leaveDay/constant/query";
import postQuery from "../../data/postData";
import SelectWorkShift from "@/components/common/workShift/select";
import CompareWorkShift from "@/components/common/workShift/Compare";
import InfoWorkShift from "@/components/common/workShift/Info";

export default {
  components: { SelectWorkShift, CompareWorkShift, InfoWorkShift },
  props: {
    employee: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => { },
    },
    updateEmployeeOnView: {
      type: Function,
      default: () => { },
    },
    refreshEmployeeAfterLeaveAnualUpdated: {
      type: Function,
      default: () => { },
    },
  },
  data() {
    return {
      form: { ...this.employee },
      annualLeaveDay: this.employee?.annualLeaveDay
        ? { ...this.employee.annualLeaveDay }
        : {},
      loadingBtn: false,
    };
  },
  computed: {
    employeeShift() {
      return (
        this.employee?.workShift ||
        this.employee?.branchLocation?.mainShift ||
        {}
      );
    },
    newEmployeeShift() {
      return (
        this.form?.workShift || this.employee?.branchLocation?.mainShift || {}
      );
    },
    isDiffShift() {
      return this.employee?.workShift?.id !== this.form?.workShift?.id;
    },
  },
  methods: {
    setFormItem(nameField, value) {
      this.$set(this.form, nameField, value);
    },
    setFormAnnualLeaveDay(nameField, value) {
      this.$set(this.annualLeaveDay, nameField, value);
    },
    checkIsDifferentDurationShift() {
      this.setFormItem(
        "isUpdateAnnualLeave",
        this.employee?.workShift?.duration !== this.form?.workShift?.duration
      );
    },
    processChangeNewAnnualLeave() {
      this.setFormAnnualLeaveDay(
        "default",
        (+this.employee?.annualLeaveDay?.default /
          (+this.employeeShift.duration || 1)) *
        +this.newEmployeeShift.duration
      );
      this.setFormAnnualLeaveDay(
        "original",
        (+this.employee?.annualLeaveDay?.original /
          (+this.employeeShift.duration || 1)) *
        +this.newEmployeeShift.duration
      );
      this.setFormAnnualLeaveDay(
        "remain",
        (+this.employee?.annualLeaveDay?.remain /
          (+this.employeeShift.duration || 1)) *
        +this.newEmployeeShift.duration
      );
    },
    async onSubmit() {
      if (this.isDiffShift && this.form.workShiftId) {
        this.loadingBtn = true;
        if (this.employee?.annualLeaveDay) {
          await this.onUpdateEmployeeAnnualLeaveDay();
        }
        await this.onUpdateEmployee();
        this.loadingBtn = false;
      }
      this.close();
    },
    async onRemoveShift() {
      this.form.workShiftId = null;
      await this.onUpdateEmployee();
      this.close();
    },
    onUpdateEmployeeAnnualLeaveDay() {
      this.loadingBtn = true;
      this.$apollo
        .mutate({
          mutation: queryAnnualLeaveDay.updateEmployeeAnnualLeaveDay,
          variables: {
            id: this.annualLeaveDay.id,
            remain: +this.annualLeaveDay.remain,
            default: +this.annualLeaveDay.default,
            original: +this.annualLeaveDay.original,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployeeAnnualLeaveDay) {
            this.refreshEmployeeAfterLeaveAnualUpdated(
              data.updateEmployeeAnnualLeaveDay
            );
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.error(
            "Cập nhật ngày nghỉ phép hằng năm của nhân viên không thành công",
            err
          );
        });
    },
    onUpdateEmployee() {
      this.$apollo
        .mutate({
          mutation: postQuery.queryUpdateEmployeeMainShift,
          variables: {
            ...this.form,
            id: this.form.id,
            workShiftId: this.form?.workShiftId ? this.form.workShiftId : null,
          },
        })
        .then(({ data }) => {
          if (data?.updateEmployee) {
            this.updateEmployeeOnView(data.updateEmployee);
            this.$notification.success({
              message: "Success",
              description: "Updated Success!",
            });
          }
        })
        .catch((error) => {
          this.$notification.error({
            message: "Error",
            description: "Updated Error!",
          });
          console.log("Không cập nhật được nhân viên", error);
        });
    },
  },
};
</script>

<style scoped>
.highlight-wrapper {
  margin-top: 20px;
  position: relative;
  border-radius: 0 0 2px 2px;
  border-top: 1px dashed #ebedf0;
  padding: 10px 0;
}

.new-shift {
  color: #32cd32 !important;
}
</style>
